import React, { useState } from 'react';
import { AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import Actions from './props/Actions';

const SMS = (props) => {
    let { activity, activityData, onUpdateActivity } = props;
    let [hovered, setHovered] = useState(false);

    const getMessagePreview = () => {
        if (activity?.description) {
            const plainText = activity.description.replace(/<[^>]*>/g, '');
            return plainText.length > 100 ? plainText.substring(0, 100) + '...' : plainText;
        }
        return 'SMS message sent';
    };

    return (
        <>
            <AccordionItemHeading>
                <AccordionItemButton>
                    <div className="activity-card sms-card">
                        <div className="activity-header">
                            <div className="activity-type-info">
                                <div className="activity-icon sms-icon">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="currentColor" />
                                        <path d="M7 7H17V9H7V7ZM7 11H17V13H7V11ZM7 15H13V17H7V15Z" fill="currentColor" />
                                    </svg>
                                </div>
                                <div className="activity-details">
                                    <div className="activity-title sms-card-title">
                                        <span className="sms-card-subject">
                                            {activity?.title || activity?.phoneNumber || 'SMS sent'}
                                        </span>
                                        <span className="sms-card-tag">sms</span>
                                    </div>
                                    <div className="activity-meta">
                                        <span className="created-by">by {activityData?.createdBy}</span>
                                        <div className="activity-badges">
                                            {activity?.metadata?.source && (() => {
                                                const meta = getSmsSourceMeta(activity.metadata.source);
                                                return (
                                                    <span className="activity-card-source" style={{ color: '#6c757d', fontSize: '11px', fontWeight: 500, display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                                        <i className={meta.icon} style={{ fontSize: '10px' }}></i>{meta.label}
                                                    </span>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="activity-actions" onClick={(e) => e.stopPropagation()}>
                                <Actions {...props} />
                                <span className="activity-time">{activityData?.createdAt}</span>
                            </div>
                        </div>

                    </div>
                </AccordionItemButton>
            </AccordionItemHeading>

            <AccordionItemPanel>
                <div className="activity-card-body sms-card-body">
                    <div className="sms-preview">
                        <div className="message-bubble">
                            {getMessagePreview()}
                        </div>
                    </div>

                    {activity?.metadata && (
                        <div className="activity-metadata">
                            {activity.metadata.messageId && (
                                <div className="metadata-item">
                                    <strong>Message ID:</strong> {activity.metadata.messageId}
                                </div>
                            )}
                            {activity.metadata.workflowId && (
                                <div className="metadata-item">
                                    <strong>Via Workflow</strong>
                                    <span className="workflow-badge">Automated</span>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </AccordionItemPanel>
        </>
    );
};

const getSmsSourceMeta = (source) => {
    if (source === 'manual') return { icon: 'fa fa-comment', label: 'Manual' };
    if (source === 'campaign') return { icon: 'fa fa-bullhorn', label: 'Campaign' };
    return { icon: 'fa fa-cog', label: 'Workflow' };
};

export default SMS;